import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

// Large, touch-friendly primary button with tap/hover micro-interactions.
export const PrimaryButton = ({
  children,
  className,
  variant = 'accent',
  onClick,
  disabled,
  type = 'button',
  ...props
}) => {
  const variants = {
    accent: 'bg-[#38BDF8] text-[#0F172A] hover:brightness-110',
    work: 'bg-[#EF4444] text-white hover:brightness-110',
    rest: 'bg-[#22C55E] text-[#0F172A] hover:brightness-110',
    ghost:
      'bg-white/5 text-white hover:bg-white/10 border border-white/10',
    danger: 'bg-white/5 text-[#F87171] border border-[#F87171]/30 hover:bg-[#EF4444]/10',
  };
  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      whileHover={{ scale: disabled ? 1 : 1.02 }}
      whileTap={{ scale: disabled ? 1 : 0.96 }}
      transition={{ duration: 0.15 }}
      className={cn(
        'min-h-[56px] rounded-2xl px-6 font-bold tracking-wide',
        'flex items-center justify-center gap-2 select-none',
        'disabled:opacity-40 disabled:cursor-not-allowed',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default PrimaryButton;
